'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoginPage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Auth = _interopRequireDefault(require("Layouts/Auth"));
var _Logo = _interopRequireDefault(require("Pure/Logo"));
var _LoginForm = _interopRequireDefault(require("Components/Forms/LoginForm"));
var _config = _interopRequireDefault(require("Shared/config"));
var _Routing = require("Functions/Routing");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  app
} = window;
function LoginPage(props) {
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    var _app$state$session, _app$state$session$us;
    if ((_app$state$session = app.state.session) !== null && _app$state$session !== void 0 && (_app$state$session$us = _app$state$session.user) !== null && _app$state$session$us !== void 0 && _app$state$session$us.id) {
      return navigate((0, _Routing.URL)(_config.default.default_home));
    }
  }, []);
  let output = /*#__PURE__*/_react.default.createElement(_Auth.default, (0, _extends2.default)({
    page_title: "Login"
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-page__left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "u-full-width"
  }, /*#__PURE__*/_react.default.createElement(_Logo.default, {
    style: {
      width: '240px',
      maxWidth: '100%',
      margin: 'auto'
    }
  }), /*#__PURE__*/_react.default.createElement(_LoginForm.default, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-page__right"
  }));
  return output;
}
